export class NatureOfAttendance{

        public idNatureOfAttendance: number;

        public natureOfAttendanceName: string;

        public datetimeInclusion: Date;
}